/**
 * The name of every skill, in one place — read by the skill's own declaration and by anything
 * that mentions it: other skills' instructions, tool descriptions, lint findings, prompts.
 *
 * This module imports nothing, so a name is readable at module-eval time from anywhere,
 * including a module that sits in an import cycle.
 *
 * The codeo and html-design registries define the same animation skills under the same names,
 * so both read the same entry.
 *
 */
export const SKILL_NAMES = {
    aiVoiceoverVideoBasics: 'ai-voiceover-video-basics',
    ambientFloatLoop: 'ambient-float-loop',
    ambientParticleField: 'ambient-particle-field',
    atmosphereGradientField: 'atmosphere-gradient-field',
    changeTemplate: 'change-template',
    chartsBasics: 'charts-basics',
    cinematicCameraMove: 'cinematic-camera-move',
    counterTickUp: 'counter-tick-up',
    createAboutUsVideo: 'create-about-us-video',
    createAnimatedVideo: 'create-animated-video',
    createBrandKit: 'create-brand-kit',
    createFaqVideo: 'create-faq-video',
    createFivePointListVideo: 'create-five-point-list-video',
    createHowToVideo: 'create-how-to-video',
    createMediaSlideshowVideo: 'create-media-slideshow-video',
    createPodcastWaveformVideo: 'create-podcast-waveform-video',
    createProblemSolutionVideo: 'create-problem-solution-video',
    createProductAdVideo: 'create-product-ad-video',
    createSimilarToVideo: 'create-similar-to-video',
    createVideo: 'create-video',
    cropMedia: 'crop-media',
    cursorClickInteraction: 'cursor-click-interaction',
    dataChart: 'data-chart',
    documentBasics: 'document-basics',
    editVideoDuration: 'edit-video-duration',
    elementMorphHandoff: 'element-morph-handoff',
    emphasisWordPulse: 'emphasis-word-pulse',
    findDamMedia: 'find-dam-media',
    findStockMedia: 'find-stock-media',
    findUserMedia: 'find-user-media',
    fixTextWrapping: 'fix-text-wrapping',
    gatherRequirements: 'gather-requirements',
    grainAndBloom: 'grain-and-bloom',
    kineticWordReveal: 'kinetic-word-reveal',
    markerEmphasis: 'marker-emphasis',
    momentSweepTransition: 'moment-sweep-transition',
    motionGraphicsScenesBasics: 'motion-graphics-scenes-basics',
    motionPolish: 'motion-polish',
    parallaxDepthDrift: 'parallax-depth-drift',
    recordedVoiceoverVideoBasics: 'recorded-voiceover-video-basics',
    reviewVideo: 'review-video',
    splitComparisonCards: 'split-comparison-cards',
    staggeredListReveal: 'staggered-list-reveal',
    statBarsAndFills: 'stat-bars-and-fills',
    svgDrawOn: 'svg-draw-on',
    svgIconEnrichment: 'svg-icon-enrichment',
    talkingHeadVideoBasics: 'talking-head-video-basics',
    textVideoBasics: 'text-video-basics',
    thirdPartyVideoLink: 'third-party-video-link',
    velocityMatchedCut: 'velocity-matched-cut',
    voiceoverVideoBasics: 'voiceover-video-basics',
    webpageScrollDemo: 'webpage-scroll-demo',
} as const;
